import { FC, useEffect } from "react";
import { Skeleton, Text } from "@chakra-ui/react";

import {
  useCheckActiveSbpTransferQuery,
  CHECK_ACTIVE_SBP_TRANSFER_QUERY_KEY,
} from "../../../../api/sbpTransfer";
import { queryClient } from "../../../../api";
import { COOLING_INFO_QUERY_KEY } from "../../../../api/cooling";
import { LocalStorageKeys } from "../../../../constants";
import { MainPageSbpTransferCooling } from "./ContentCooling";
import { MainPageSbpTransferInProgress } from "./ContentInProgress";

interface Props {
  isCoolingFetching: boolean;
  isCoolingActive: boolean | undefined;
}

export const MainPageSbpTransferContent: FC<Props> = ({ isCoolingFetching, isCoolingActive }) => {
  const {
    data: activeSbpTransfer,
    isFetching: isActiveSbpTransferFetching,
    refetch: refetchSbpTransferStatus,
  } = useCheckActiveSbpTransferQuery();

  useEffect(() => {
    const STORAGE_KEY = LocalStorageKeys.hasActiveSbpTransfer;

    if (activeSbpTransfer?.isTrancheActive) {
      localStorage.setItem(STORAGE_KEY, "true");
    }

    if (!activeSbpTransfer?.isTrancheActive && localStorage.getItem(STORAGE_KEY) === "true") {
      localStorage.removeItem(STORAGE_KEY);

      void queryClient.invalidateQueries({
        predicate: (query) => {
          const currentQueryKey = query.queryKey;
          const queriesForSkipping = [COOLING_INFO_QUERY_KEY, CHECK_ACTIVE_SBP_TRANSFER_QUERY_KEY];

          return !queriesForSkipping.includes(currentQueryKey[0] as string);
        },
      });
    }
  }, [activeSbpTransfer?.isTrancheActive]);

  if (isCoolingFetching || isActiveSbpTransferFetching) {
    return <Skeleton h="20px" mb="11px" />;
  }

  if (isCoolingActive) {
    return <MainPageSbpTransferCooling />;
  }

  if (activeSbpTransfer?.isTrancheActive) {
    return <MainPageSbpTransferInProgress amount={activeSbpTransfer.amount} refetch={refetchSbpTransferStatus} />;
  }

  return <Text mb="11px" fontSize="14px">Отправьте часть лимита себе на счет через СБП</Text>;
};
